import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

import HomePage from './pages/HomePage.vue'
import CodePage from './pages/CodePage.vue'
import MusicPage from './pages/MusicPage.vue'
import StuffPage from './pages/StuffPage.vue'

Vue.use(Router)

const routes = [
  { name: 'home', path: '/', component: HomePage },
  { name: 'code', path: '/code', component: CodePage },
  { name: 'music', path: '/music', component: MusicPage },
  { name: 'stuff', path: '/stuff', component: StuffPage }
]

const router = new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js